import { Inventory, InventoryItem, WeaponCharacteristics } from "game-common/models"
import { Mechanics } from "game-common/mechanics/mechanics"

// What sits on the ready bar, in slot order: readied weapons, items with a primary use, and every
// structure (crafting readies any it makes). One rule, shared by the tray (which draws a well per item
// and numbers them 1, 2, 3...) and by anything that has to name a slot by its key (the controls
// lesson's "press 1 to take it back out"), so the two can never disagree.
export const readyBarItems = (inventory: Inventory | undefined): InventoryItem[] =>
    (inventory?.items || []).filter(
        item => item.readied && (WeaponCharacteristics[item.itemType]?.slotVisible ||
            Mechanics.item.properties.primaryUseable(item.itemTypeMeta) ||
            item.itemTypeMeta?.class === "structure"),
    )

/** The slot holding this item on the ready bar, numbered as its key is (from 1), or undefined. */
export const readyBarSlotOf = (inventory: Inventory | undefined, itemId: string): number | undefined => {
    const index = readyBarItems(inventory).findIndex(item => item.id === itemId)
    return index < 0 ? undefined : index + 1
}
